import React from 'react';

const RssFeedPage = (props) => (
	<div className="container main">
		<h2>RSS Feed</h2>
		<div className="row">
			<div className="col-sm-12">
				<p>製品リコールに関するOECDグローバルポータルに投稿された最新のリコールに関する通知を受け取りますか？</p>
				<p>
					<a className={'rss-feed-link'} href={props.config.api + '/rss.xqy'}>RSSフィードを購読します。</a>
				</p>
				<p>次のような他のさまざまな方法でフィードを購読することもできます。</p>
				<ul className={'rss-feed-options'}>
					<li>RSSフィードのURLをニュースリーダーにコピーします。</li>
					<li>RSSフィードのURLをブラウザーにコピーします。</li>
				</ul>
			</div>
		</div>
	</div>
);

export default RssFeedPage;



// WEBPACK FOOTER //
// ./src/views/static/ja/rss-feed.js